import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { AvatarComponent } from '../avatar/avatar.component';
import { DropdownHeaderComponent } from '../dropdown/dropdown-header/dropdown-header.component';
import { DropdownItemComponent } from '../dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { HeadingComponent } from '../heading/heading.component';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';
import { TruncateComponent } from '../truncate/truncate.component';

@Component({
  selector: 'rt-mail-picker',
  templateUrl: './mail-picker.component.html',
  styleUrls: ['./mail-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarComponent,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    HeadingComponent,
    IconColorDirective,
    IconComponent,
    NgFor,
    NgIf,
    TranslatePipe,
    TruncateComponent,
  ],
})

// TODO: This component should not be the part of UI lib
export class MailPickerComponent {
  @Input() public index: number;
  @Input() public tag: {
    candidateId?: number;
    candidate?: {
      id: number;
      photoThumbUrl: string;
      name: string;
      placements: Array<{ offer: { title: string } }>;
      emails: string[];
      initials: string;
      hasAvatar: boolean;
    };
    adminId?: number;
    admin?: {
      photoThumbUrl: string;
      initials: string;
      hasAvatar: boolean;
    };
    email: string;
    name: string;
  };
  @Input() public selectCandidate: boolean = false;

  @Output() public openCandidate: EventEmitter<{ id: number }> = new EventEmitter();
  @Output() public emailSelect: EventEmitter<{
    index: number;
    email: string;
  }> = new EventEmitter();

  public isCandidate(): boolean {
    return !!this.tag.candidateId || this.selectCandidate;
  }

  public isAdmin(): boolean {
    return !!this.tag.adminId && !this.selectCandidate;
  }

  public showCandidate(): void {
    if (this.tag.candidate) {
      this.openCandidate.emit(this.tag.candidate);
    }
  }

  public isEmailActive(email: string): boolean {
    return this.tag.email === email;
  }

  public select(email: string): void {
    this.emailSelect.emit({
      index: this.index,
      email: email,
    });
  }

  public trackByEmail(index: number, email: string): string {
    return email;
  }
}
